import {
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IObjectColorConfiguration,
  IEnableConfiguration,
  IColorFixedObjectStyleConfiguration,
} from "../../../../domain/configuration";
import { PaintStyle } from "../../../../domain/drawing";
import { CircleSelectItem } from "../../../../domain/document/items";
import { AbstractObjectStyleReader } from "./AbstractObjectStyleReader";
import { FixedColorSource } from "./FixedColorSource";

export class CircleSelectObjectStyleReader extends AbstractObjectStyleReader<CircleSelectItem> {
  constructor(private readonly _configuration: IColorFixedObjectStyleConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: CircleSelectItem): PaintStyle {
    return source.paintStyleOnEditing;
  }

  protected readBackgroundColorConfiguration(source: CircleSelectItem): IBackgroundColorConfiguration {
    return this.readObjectStyleConfiguration(source);
  }

  protected readBorderColorConfiguration(source: CircleSelectItem): IBorderColorConfiguration {
    return this.readObjectStyleConfiguration(source);
  }

  private readObjectStyleConfiguration(source: CircleSelectItem): IObjectColorConfiguration {
    if ((source.injectedRule && source.injectedRule.isEditDisabled) || !source.isFreeInputable) {
      return FixedColorSource.uneditableCircleSelect;
    }
    return this._configuration.default;
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return null;
  }
}
